export default {
  isSignupModalOpen: state => state.signupModalOpen,
}
